<template>
  <div id="trivia">

    <section class="bannerprincipal">
      <SiteNav v-if="showNav"></SiteNav>
      <div
        v-if="!showNav"
        class="col-12 text-center"
        data-aos="fade-down"
        data-aos-delay="100"
      >
        <!-- <router-link to="/">
          <img
            class="pt-5 img-fluid"
            src="../assets/imgs/homecapistrano/texto-1.png"
            alt="Copa Prosa"
          />
        </router-link> -->
      </div>

      <div class=""></div>
    </section>


    <section class="pt-5 mt-5">
      <div class="container pt-2 mt-5">
        <div class="row pt-5">
          <div class="col-12">
            <div class="py-t justified negro">
              <h1 style="text-align: center" class="pb-4">
                <strong>Aviso de Privacidad Integral</strong>
              </h1>
              <p
                style="
                  margin: 0in;
                  font-size: 16px;

                  text-align: justify;
                  padding: 0 !important;
                "
                class="negro"
              >
                Para Promoción y Operación S.A. de C.V. es muy importante
                mantener la privacidad y confianza de sus Clientes, con el
                propósito de asegurar que se conozca cómo salvaguardamos la
                integridad, privacidad y protección de sus datos personales, le
                damos a conocer el aviso de privacidad integral para Clientes,
                en apego a la Ley Federal de Protección de Datos Personales en
                Posesión de los Particulares (LFPDPPP) y su Reglamento.&nbsp;
              </p>
              <p>&nbsp;</p>
              <p>
                Por lo anterior solicitamos que lea atentamente la siguiente
                información:&nbsp;
              </p>
              <p>&nbsp;</p>
              <p>1.- IDENTIDAD Y DOMICILIO DEL RESPONSABLE</p>
              <p>&nbsp;</p>
              <p>
                Promoción y Operación S.A de C.V. (PROSA) declara ser una
                empresa legalmente constituida de conformidad con las leyes
                mexicanas, con domicilio ubicado en Bahía de Chachalacas #7,
                Colonia Verónica Anzures, Alcaldía Miguel Hidalgo, C.P.11300,
                Ciudad de México. Así como manifestar ser la encargada del
                tratamiento de sus datos personales.
              </p>
              <p>&nbsp;</p>
              <p>
                Para solicitudes e información, se cuenta con un servicio de
                atención, en el número telefónico (55) 55 5268-1515 en un
                horario de 9:00 a 18:00 hrs. de lunes a viernes, así como el
                correo electrónico procliente@prosa.com.mx
              </p>
              <p>&nbsp;</p>
              <p>
                Nuestro aviso de privacidad integral para Clientes, se podrá
                consultar en los portales de internet:
                https://www.prosamexico.mx, https://carnet.mx y
                https://promocionesmsi.com.mx, localizado en la parte inferior
                de la página principal.
              </p>
              <p>&nbsp;</p>
              <p>2.- DATOS PERSONALES</p>
              <p>&nbsp;</p>
              <p>
                PROSA, recabará datos personales (personas físicas), que sean
                necesarios para las finalidades señaladas en el presente aviso
                de privacidad, para lo cual se pueden recabar sus datos
                personales de forma directa o cuando usted mismo nos los
                proporcione por diversos medios.&nbsp;
              </p>
              <p>&nbsp;</p>
              <p>
                Dichos datos personales podrán incluir todos o algunos de los
                siguientes:
              </p>
              <p>&nbsp;</p>
              <p>i. Datos de identificación;</p>
              <p>ii. Datos laborales;</p>
              <p>iii. Datos de contacto;</p>
              <p>iv. Datos profesionales (académicos); y</p>
              <p>v. Datos migratorios.&nbsp;</p>
              <p>&nbsp;</p>
              <p>
                <strong>&nbsp;</strong>
              </p>
              <p>&nbsp;</p>
              <p>3.- DATOS SENSIBLES</p>
              <p>&nbsp;</p>
              <p>
                Se le informa que PROSA no recabará datos personales sensibles,
                se consideran “Datos Sensibles” aquellos datos personales que
                afecten a la esfera más íntima de su titular, o cuya utilización
                indebida pueda dar origen a discriminación o conlleve un riesgo
                grave para éste. En particular, se consideran datos sensibles,
                aquellos que puedan revelar aspectos como origen racial o
                étnico, estado de salud presente y futura, información genética,
                creencias religiosas, filosóficas y morales, afiliación
                sindical, opiniones políticas, preferencia sexual.
              </p>
              <p>&nbsp;</p>
              <p>4.- FINALIDADES DEL TRATAMIENTO DE DATOS</p>
              <p>&nbsp;</p>
              <p>
                PROSA tratará los datos personales única y exclusivamente
                conforme a las siguientes finalidades:&nbsp;
              </p>
              <p>&nbsp;</p>
              <p
                style="
                  margin: 0in;
                  font-size: 16px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                  padding: 0 !important;
                  text-indent: 0.25in;
                "
              >
                Finalidad Primaria&nbsp;
              </p>
              <p>&nbsp;</p>
              <div
                style="
                  margin: 0in;
                  font-size: 16px;
                  font-family: 'Calibri', sans-serif;
                "
              >
                <ul style="margin-bottom: 0in; list-style-type: disc">
                  <li
                    style="
                      margin: 0in;
                      font-size: 16px;
                      font-family: 'Calibri', sans-serif;
                    "
                  >
                    Aquellas &nbsp;que son indispensables para el cumplimiento
                    de la relación jurídica, entre PROSA y la empresa para la
                    que usted trabaja, las cuales son: (i) corroborar su
                    identidad y veracidad de la información proporcionada; (ii)
                    integrar expedientes y sistemas necesarios para llevar a
                    cabo las operaciones correspondientes; y (iii) mantener la
                    relación jurídica con PROSA o para la contratación de nuevos
                    productos o servicios.
                  </li>
                </ul>
              </div>
              <p
                style="
                  margin: 0in;
                  font-size: 16px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                  padding: 0 !important;
                  text-indent: 0.25in;
                "
              >
                &nbsp;
              </p>
              <p
                style="
                  margin: 0in;
                  font-size: 16px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                  padding: 0 !important;
                  text-indent: 0.25in;
                "
              >
                Finalidad Secundaria&nbsp;
              </p>
              <p>&nbsp;</p>
              <div
                style="
                  margin: 0in;
                  font-size: 16px;
                  font-family: 'Calibri', sans-serif;
                "
              >
                <ul style="margin-bottom: 0in; list-style-type: disc">
                  <li
                    style="
                      margin: 0in;
                      font-size: 16px;
                      font-family: 'Calibri', sans-serif;
                    "
                  >
                    Aquellas no indispensables para el cumplimiento de la
                    relación jurídica; de manera opcional se pondrán utilizar
                    en: (i) consultas, evaluaciones y encuestas de satisfacción;
                    (ii) publicidad; (iii) marketing; (iv) prospección
                    comercial; y (v) remitir productos o servicios relacionados.
                  </li>
                </ul>
              </div>
              <p
                style="
                  margin-top: 0in;
                  margin-right: 0in;
                  margin-bottom: 0in;
                  margin-left: 0.5in;
                  font-size: 16px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                  padding: 0 !important;
                "
              >
                &nbsp;
              </p>
              <p>5.- MECANISMOS PARA QUE PUEDA MANISFESTAR SU NEGATIVA</p>
              <p>&nbsp;</p>
              <p>
                En el caso de que no desee que se traten sus datos personales
                para las mencionadas finalidades secundarias, favor de referirse
                a nuestro servicio de atención a Clientes cuyos datos están
                mencionados al inicio del presente aviso de privacidad y
                solicitar el formato “Formato de Solicitud para ejercer el
                Derecho ARCO” para iniciar el procedimiento correspondiente que
                se describe en el punto siete del presente aviso de privacidad.
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>6.- TRANSFERENCIA DE DATOS PERSONALES</p>
              <p>&nbsp;</p>
              <p>
                Con el propósito de brindar un mejor servicio y conocer la
                opinión de nuestros Clientes, PROSA requiere transferir sus
                datos personales, solo al interior de la República Mexicana; así
                como también, &nbsp;se compromete a velar para que se cumplan
                todos los principios legales de protección en torno a la
                transferencia de sus datos personales. De igual forma,
                manifiesta su compromiso para que se respete en todo momento,
                por nosotros y por nuestros socios comerciales y empresas
                contratadas por PROSA, el presente aviso de privacidad y la
                confidencialidad de su información.&nbsp;
              </p>
              <p>&nbsp;</p>
              <p
                style="
                  margin: 0in;
                  font-size: 16px;
                  font-family: 'Calibri', sans-serif;
                  margin-bottom: 10pt;
                  text-align: justify;
                  padding: 0 !important;
                "
              >
                Conforme a lo mencionado, le informamos que se podrá llevar a
                cabo la transferencia de sus datos personales a:
              </p>
              <table style="border-collapse: collapse; border: none">
                <tbody>
                  <tr>
                    <td
                      style="
                        width: 224.45pt;
                        border: solid windowtext 1pt;
                        padding: 0in 5.4pt 0in 5.4pt;
                        height: 18.7pt;
                      "
                    >
                      <p
                        style="
                          margin: 0in;
                          font-size: 16px;
                          font-family: 'Calibri', sans-serif;
                          text-align: center;
                        "
                      >
                        Destinatario de los Datos Personales
                      </p>
                    </td>
                    <td
                      style="
                        width: 224.45pt;
                        border: solid windowtext 1pt;
                        border-left: none;
                        padding: 0in 5.4pt 0in 5.4pt;
                        height: 18.7pt;
                      "
                    >
                      <p
                        style="
                          margin: 0in;
                          font-size: 16px;
                          font-family: 'Calibri', sans-serif;
                          text-align: center;
                        "
                      >
                        Finalidad
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        width: 224.45pt;
                        border: solid windowtext 1pt;
                        border-top: none;
                        padding: 0in 5.4pt 0in 5.4pt;
                        height: 28.25pt;
                      "
                    >
                      <p
                        style="
                          margin: 0in;
                          font-size: 16px;
                          font-family: 'Calibri', sans-serif;
                          text-align: justify;
                          padding: 0 !important;
                        "
                      >
                        Compañías / plataformas especializadas para realizar
                        consultas y encuestas de satisfacción, contratadas por
                        PROSA.
                      </p>
                    </td>
                    <td
                      style="
                        width: 224.45pt;
                        border-top: none;
                        border-left: none;
                        border-bottom: solid windowtext 1pt;
                        border-right: solid windowtext 1pt;
                        padding: 0in 5.4pt 0in 5.4pt;
                        height: 28.25pt;
                      "
                    >
                      <p
                        style="
                          margin: 0in;
                          font-size: 16px;
                          font-family: 'Calibri', sans-serif;
                          margin-bottom: 10pt;
                          text-align: justify;
                          padding: 0 !important;
                          line-height: 115%;
                        "
                      >
                        Conocer y evaluar la opinión de Clientes, respecto a los
                        productos y/o servicios brindados por PROSA.
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p>&nbsp;</p>
              <p>6. CLÁUSULA DE ACEPTACIÓN</p>
              <p>&nbsp;</p>
              <p>
                Todo tratamiento de datos personales estará sujeto al
                consentimiento de su titular, salvo las excepciones previstas
                por la LFPDPPP y su Reglamento. Por lo anterior, se entenderá
                que el titular consiente que al no manifestar su oposición, de
                acuerdo a lo establecido en el presente aviso de privacidad, se
                entenderá como su afirmativa ficta a los términos y condiciones
                expuestos en el presente documento.
              </p>
              <p>&nbsp;</p>
              <p>
                Los datos financieros o patrimoniales requerirán el
                consentimiento expreso de su titular, salvo las excepciones a
                las que se refieren los artículos 10 y 37 de la LFPDPPP.
              </p>
              <p>&nbsp;</p>
              <p>
                El consentimiento podrá ser revocado en cualquier momento sin
                que se le atribuyan efectos retroactivos.
              </p>
              <p>&nbsp;</p>
              <p>
                Cuando el aviso de privacidad no se haga del conocimiento del
                titular de manera directa o personal, el titular tendrá un plazo
                de cinco días para que, de ser el caso, manifieste su negativa
                para el tratamiento de datos personales para las finalidades que
                sean distintas a aquéllas que son necesarias y den origen a la
                relación jurídica entre el responsable y el titular.
              </p>
              <p>&nbsp;</p>
              <p>
                Si el titular no manifiesta su negativa para el tratamiento de
                sus datos de conformidad con lo anterior, se entenderá que ha
                otorgado su consentimiento para el tratamiento de los mismos,
                salvo prueba en contrario.
              </p>
              <p>&nbsp;</p>
              <p>
                7.- MEDIOS PARA EJERCER LOS DERECHOS ARCO (Acceso,
                Rectificación, Cancelación u Oposición).
              </p>
              <p>&nbsp;</p>
              <p>
                Tiene derecho a conocer qué datos personales tenemos de usted,
                para qué los utilizamos y las condiciones del uso que les damos
                (“Acceso”). Asimismo, es su derecho solicitar la corrección de
                su información personal en caso de que esté desactualizada, sea
                inexacta o incompleta (“Rectificación”); que la eliminemos de
                nuestros registros o bases de datos cuando considere que la
                misma no está siendo utilizada adecuadamente (“Cancelación”);
                así como oponerse al uso de sus datos personales para fines
                específicos (“Oposición”). Estos derechos se conocen como
                Derechos ARCO.&nbsp;
              </p>
              <p>&nbsp;</p>
              <p>
                Para el ejercicio de cualquiera de los Derechos ARCO, deberá
                seguir el siguiente procedimiento y reunir los requisitos
                mencionados:&nbsp;
              </p>
              <p>&nbsp;</p>
              <p>
                I. El procedimiento inicia con la petición del “Formato de
                Solicitud para ejercer el Derecho ARCO” (El Formato) mismo que
                puede solicitar a través de nuestro centro de atención, &nbsp;a
                Clientes.&nbsp;
              </p>
              <p>&nbsp;</p>
              <p>
                II. El Formato debidamente llenado y firmado se deberá enviar a
                la dirección de correo&nbsp;<a
                  href="mailto:procliente@prosa.com.mx"
                  >procliente@prosa.com.mx</a
                >&nbsp; acompañado de la siguiente documentación escaneada, a
                fin de poder realizar una autenticación del titular que desee
                ejercer su Derecho ARCO:&nbsp;
              </p>
              <p>&nbsp;</p>
              <p
                style="
                  margin: 0in;
                  font-size: 16px;
                  font-family: 'Calibri', sans-serif;
                  margin-left: 35.4pt;
                  text-align: justify;
                  padding: 0 !important;
                "
              >
                a. Identificación oficial vigente (Credencial del Instituto
                Nacional Electoral, Pasaporte, Cartilla de Servicio Militar
                Nacional o Cédula Profesional).
              </p>
              <p>&nbsp;</p>
              <p
                style="
                  margin: 0in;
                  font-size: 16px;
                  font-family: 'Calibri', sans-serif;
                  margin-left: 35.4pt;
                  text-align: justify;
                  padding: 0 !important;
                "
              >
                b. En los casos en que el ejercicio de los Derechos ARCO se
                realice a través del representante legal del titular, además de
                la acreditación de la identidad de ambos, se deberá entregar el
                poder notarial correspondiente, carta poder firmada ante dos
                testigos o declaración en comparecencia del titular.
              </p>
              <p>&nbsp;</p>
              <p
                style="
                  margin: 0in;
                  font-size: 16px;
                  font-family: 'Calibri', sans-serif;
                  margin-left: 35.4pt;
                  text-align: justify;
                  padding: 0 !important;
                "
              >
                c. Cuando se quiera ejercer el derecho de rectificación, se
                tendrá que entregar la documentación que acredite el cambio
                solicitado de acuerdo a los datos personales a rectificar.
              </p>
              <p>&nbsp;</p>
              <p>
                III. La respuesta a dicho Formato, se llevará a cabo por PROSA,
                durante los siguientes 20 días hábiles contados a partir de la
                fecha en que fue recibido el mismo. Se podrá ampliar este plazo
                en el caso de que la información proporcionada en la solicitud
                sea insuficiente o errónea para atenderla, o bien, no se
                acompañen los documentos a que hacen referencia, se requerirá,
                por una vez y dentro de los 5 días hábiles siguientes a la
                recepción de la solicitud, que aporte los elementos o documentos
                necesarios para dar trámite a la misma. El titular contará con
                10 días hábiles para atender el requerimiento, contados a partir
                del día siguiente en que lo haya recibido. De no dar respuesta
                en dicho plazo, se tendrá por no presentada la solicitud
                correspondiente. En caso de que el titular atienda el
                requerimiento de información, el plazo de respuesta a la
                solicitud empezará a correr al día siguiente de que el titular
                haya atendido el requerimiento (Es decir, los 15 días hábiles
                restantes).&nbsp;
              </p>
              <p>&nbsp;</p>
              <p>
                En cada etapa del procedimiento el titular recibirá un acuse de
                recibo con la fecha correspondiente.
              </p>
              <p>&nbsp;</p>
              <p>
                La resolución adoptada por PROSA, será comunicada al titular a
                través de las opciones elegidas por éste, las cuales se
                encuentran establecidas en el “formato”.
              </p>
              <p>&nbsp;</p>
              <p>8.- MECANISMOS PARA QUE PUEDA MANIFESTAR SU REVOCACIÓN</p>
              <p>&nbsp;</p>
              <p>
                En los casos en que el titular desee revocar la autorización
                otorgada a PROSA, respecto de los datos personales
                proporcionados, deberá realizar la solicitud correspondiente en
                los mismos términos establecidos en el presente aviso de
                privacidad para ejercer su Derecho ARCO.
              </p>
              <p>&nbsp;</p>
              <p>9.- LIMITACIÓN DE USO O DIVULGACIÓN</p>
              <p>&nbsp;</p>
              <p>
                PROSA no usa o divulga información para fines distintos a los
                mencionados en el presente aviso de privacidad.&nbsp;
              </p>
              <p>&nbsp;</p>
              <p>
                Con el objeto de que pueda limitar el uso y divulgación de su
                información personal, lo puede hacer por medio de la inscripción
                en el “Registro Público para Evitar Publicidad”, que está a
                cargo de la Procuraduría Federal del Consumidor, con la
                finalidad de que sus datos personales no sean utilizados para
                recibir publicidad o promociones de empresas de bienes o
                servicios.&nbsp;
              </p>
              <p>&nbsp;</p>
              <p>
                Para mayor información sobre este registro, puede consultar el
                portal de Internet de la PROFECO, o bien ponerse en contacto
                directo con ésta.
              </p>
              <p>&nbsp;</p>
              <p>10.- NUESTRO PORTAL DE INTERNET</p>
              <p>&nbsp;</p>
              <p>
                Los portales de PROSA, se utilizan principalmente para cubrir
                los siguientes propósitos:&nbsp;
              </p>
              <p>&nbsp;</p>
              <p>(i) Facilitar el acceso a los servicios de PROSA.&nbsp;</p>
              <p>
                (ii) Publicar y dar a conocer su aviso de privacidad integral.
              </p>
              <p>&nbsp;</p>
              <p>
                Al acceder a los portales de PROSA, se establece una sesión
                segura mediante el protocolo SSL (Secure Socket Layer) que nos
                permite que toda la información que viaje desde nuestros
                servidores hacia su terminal y viceversa se mantenga protegida
                contra acceso indebido.&nbsp;
              </p>
              <p>&nbsp;</p>
              <p>
                Los portales de PROSA y sus diferentes sitios de internet a los
                que se enlaza se basan en el manejo de Cookies y/o Web Beacons
                que exclusivamente se utilizan para mejorar la experiencia de
                navegación, medir nuestra audiencia y mostrar contenido basado
                en la interacción de la página.&nbsp;
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>11.- CAMBIOS AL AVISO DE PRIVACIDAD</p>
              <p>&nbsp;</p>
              <p>
                Nos reservamos el derecho de efectuar en cualquier momento
                modificaciones o actualizaciones al presente aviso de
                privacidad, para la atención de reformas a la Leyes aplicables,
                políticas internas o nuevos requerimientos para la prestación u
                ofrecimiento de nuestros productos o servicios.&nbsp;
              </p>
              <p>&nbsp;</p>
              <p>
                Por lo que podrá consultar y estar informado de las
                actualizaciones al aviso de privacidad, ingresando a los
                portales https://www.prosamexico.mx, https://carnet.mx y
                https://promocionesmsi.com.mx.
              </p>
              <p>&nbsp;</p>
              <p
                style="
                  margin: 0cm;
                  font-size: 16px;
                  font-family: 'Calibri', sans-serif;
                  text-align: justify;
                  margin-bottom: 10px;
                  font-weight: bold;
                "
              >
                Fecha de actualización: 30 de junio de 2021
              </p>
            </div>
          </div>

          <div class="col-12 py-5"></div>
          <div class="col-12 py-5"></div>
          <div class="col-12 py-5"></div>
          <div class="col-12 py-5"></div>
          <div class="col-12 py-5"></div>
        </div>
      </div>
    </section>

    <FooterTerminos></FooterTerminos>
  </div>
</template>

<script>
import SiteNav from "@/components/SiteNavInterior";
import swal from "sweetalert2";

import FooterTerminos from "@/components/FooterTerminos";

export default {
  components: {
    FooterTerminos,
    SiteNav
  },
  data() {
    return {};
  },
  computed: {
    
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
  },
  mounted: function () {},
};
</script>

<style lang="scss" scoped>
ul {
  li {
    list-style: none;
  }
}
table {
  margin: 0 auto !important;
  border: 1px solid #afafaf;
}
</style>
